





import {Component} from 'vue-property-decorator'
import Posts from '@/components/admin/Posts.vue'
import Recruit, {IRecruit} from '@/models/Recruit'
import PageBase, {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    Posts
  }
})
export default class RecruitIndex extends PageBase {
  headers = [
    { text: '', value: 'actions', sortable: false, width: 70 },
    { text: 'タイトル', value: 'title', width: 500 },
    { text: '契約形態', value: 'planString', width: 220 },
    { text: '公開日時', value: 'publishAtNumber', width: 180 },
    { text: '変更日時', value: 'updatedAtNumber', width: 180 },
    { text: 'SEOタイトル', value: 'seo_title', width: 300 },
    { text: 'SEOディスクリプション', value: 'seo_description', width: 300 }
  ]

  mounted(): void {
    super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '求人情報一覧'
      }
    ]
  }

  toD(data: Array<IRecruit>): Array<Recruit> {
    return data.map(d => new Recruit(d))
  }
}
